import { toast } from '@/hooks/use-toast';

// Redirect lock to prevent multiple simultaneous redirects
// Use a promise-based approach to ensure only one redirect happens
let redirectPromise = null;

export const redirectToOAuth = (oauthUrl, delaySeconds = 3) => {
    if (!oauthUrl) return;

    // If a redirect is already in progress, return the existing promise
    // This ensures all callers wait for the same redirect
    if (redirectPromise) {
        return redirectPromise;
    }

    // Create a new promise for this redirect
    redirectPromise = new Promise((resolve) => {
        let countdown = delaySeconds;

        // Show initial toast with countdown
        const { id, update, dismiss } = toast({
            title: "Redirecting...",
            description: `Re-authenticating in ${countdown} seconds...`,
            variant: "info",
            duration: 0, // Don't auto-dismiss
        });

        // Countdown interval
        const countdownInterval = setInterval(() => {
            countdown--;

            if (countdown > 0) {
                // Update toast message
                update({
                    title: "Redirecting...",
                    description: `Re-authenticating in ${countdown} seconds...`,
                    variant: "info",
                });
            } else {
                // Clear interval and dismiss toast
                clearInterval(countdownInterval);
                dismiss();

                // Perform the redirect
                window.open(oauthUrl, '_self');
                resolve();
            }
        }, 1000);

        // Reset the lock after a delay to allow new redirects if needed
        // This handles edge cases where redirect might not happen
        setTimeout(() => {
            redirectPromise = null;
        }, (delaySeconds + 1) * 1000);
    });

    return redirectPromise;
};